import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PhotographerCardComponent } from './photographer-card/photographer-card.component';
import { MPMaterialModule } from "./material.module";
import { MainComponent } from './main/main.component';
import { GuestMenuComponent } from './guest-menu/guest-menu.component';
import { GuestSidenavMenuComponent } from './guest-sidenav-menu/guest-sidenav-menu.component';
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { SearchComponent } from './guest-menu/search/search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchResultsComponent } from './guest-menu/search/search-results/search-results.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { GuestMenuTracking } from './guest-menu/guest-menu-tracking.component';

@NgModule({
  declarations: [
    AppComponent,
    PhotographerCardComponent,
    MainComponent,
    GuestMenuComponent,
    GuestSidenavMenuComponent,
    SearchComponent,
    SearchResultsComponent,
    GuestMenuTracking
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MPMaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    OverlayModule
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
